import { Control } from './control';
import { GenericAlarmFormat } from './generic-alarm-format';

export class GenericAlarm {
  constructor(
    public hash?: string,
    public active?: boolean,
    public format?: GenericAlarmFormat,
    public dateRegex?: string,
    public genericTxt?: string,
    public control?: Control,
  ) { }

  clone() {
    return new GenericAlarm(
      this.hash,
      this.active,
      this.format,
      this.dateRegex,
      this.genericTxt,
      this.control
    );
  }

  get formatName() {
    return this.format ? this.format.name : '';
  }

  get controlName() {
    return this.control ? this.control.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/generic-alarm.ts